// frontend/app/VersionBadge.js
import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet } from "react-native";

export default function VersionBadge({ isDarkMode = false }) {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let alive = true;

    fetch("/version.json", { cache: "no-store" })
      .then((r) => {
        if (!r.ok) throw new Error(`version.json HTTP ${r.status}`);
        return r.json();
      })
      .then((j) => alive && setInfo(j))
      .catch(() => alive && setInfo(null));

    return () => {
      alive = false;
    };
  }, []);

  if (!info) return null;

  const release = info.release_id || "unknown";
  const assetPack = info.asset_pack_id || "unknown";
  const contentExport = info?.content?.export_id;

  const line = `Saras-3D AI Tutor Version: ${release} | ${assetPack}`;

  return (
    // pointerEvents none so it never blocks your buttons/input
    <View pointerEvents="none" style={styles.wrap}>
      <Text
        style={[
          styles.text,
          isDarkMode ? styles.textDark : styles.textLight,
        ]}
        numberOfLines={1}
      >
        {line}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    width: "100%",
    alignItems: "center",
    paddingTop: 6,
    paddingBottom: 2,
  },
  text: {
    fontSize: 11,
    letterSpacing: 0.2,
    opacity: 0.65, // makes it faint
  },
  textLight: {
    color: "#64748b",
  },
  textDark: {
    color: "#94a3b8",
  },
});
